// SimpleForms
import EmpresaForm from "../views/simpleForms/EmpresaForm.vue";
import MedicoForm from "../views/simpleForms/MedicoForm.vue";
import PersonaForm from "../views/simpleForms/PersonaForm.vue";
import SuscripcionForm from "../views/simpleForms/SuscripcionForm.vue";
import PlanillaForm from "../views/simpleForms/PlanillaForm.vue";
import PlanillaFormPopup from "../views/simpleForms/PlanillaFormPopup.vue";
import PlanillaCrearForm from "../views/simpleForms/PlanillaCrearForm.vue";
import TramiteForm from "../views/simpleForms/TramiteForm.vue";
import TramiteFormCarga from "../views/simpleForms/TramiteFormCarga.vue";
import TramiteFormCargaAut from "../views/simpleForms/TramiteFormCargaAut.vue";
import CargaForm from "../views/simpleForms/CargaForm.vue";
import PlaObsFormR from "../views/simpleForms/PlaObsFormR.vue";
import PlaDetObsFormR from "../views/simpleForms/PlaDetObsFormR.vue";
import TarifarioForm from "../views/simpleForms/TarifarioForm.vue";
import AseguradorForm from "../views/simpleForms/AseguradorForm.vue";
import PrestadorForm from "../views/simpleForms/PrestadorForm.vue";

export default [
  {
    path: "/empresaform/:p_idempresa",
    name: "EmpresaForm",
    component: EmpresaForm,
  },
  {
    path: "/medicoform/:p_idmedico",
    name: "MedicoForm",
    component: MedicoForm,
  },
  {
    path: "/personaform/:p_idpersona",
    name: "PersonaForm",
    component: PersonaForm,
  },
  {
    path: "/suscripcionform/:p_idsuscripcion",
    name: "SuscripcionForm",
    component: SuscripcionForm,
  },
  {
    path: "/planillaform/:p_idtramite/:p_estadotramite/:p_idplanilla",
    name: "PlanillaForm",
    component: PlanillaForm,
  },
  {
    path: "/planillaformpopup",
    name: "PlanillaFormPopup",
    component: PlanillaFormPopup,
  },
  {
    path: "/planillacrearform/:p_idtramite/:p_idplanilla",
    name: "PlanillaCrearForm",
    component: PlanillaCrearForm,
  },
  {
    path: "/tramiteform/:p_idtramite",
    name: "TramiteForm",
    component: TramiteForm,
  },
  {
    path: "/tramiteform-carga/:p_idtramite",
    name: "TramiteForm Carga",
    component: TramiteFormCarga,
  },
  {
    path: "/tramiteform-carga-aut/:p_idtramite/:p_idautorizacion",
    name: "TramiteForm Carga Aut",
    component: TramiteFormCargaAut,
  },
  {
    path: "/cargaform/:p_idtramite/:p_idcarga",
    name: "CargaForm",
    component: CargaForm,
  },
  {
    path: "/pla-obs-respuesta/:p_idplaobs/:p_observaciontipo",
    name: "PlaObsFormR",
    component: PlaObsFormR,
  },
  {
    path: "/pla-det-obs-respuesta/:p_idpladetobs/:p_observaciontipo",
    name: "PlaDetObsFormR",
    component: PlaDetObsFormR,
  },
  {
    path: "/tarifarioform/:p_idtarifario",
    name: "TarifarioForm",
    component: TarifarioForm,
  },
  {
    path: "/aseguradorform/:p_idasegurador",
    name: "AseguradorForm",
    component: AseguradorForm,
  },
  {
    path: "/prestadorform/:p_idprestador",
    name: "PrestadorForm",
    component: PrestadorForm,
  },
];
